<template>
  <div class="search-content">
    <div class="search-nav">
      <div
        class="search-nav-back"
        @click="back()">
        <img src="../assets/images/nav/back1.png" />
      </div>
      <h4>{{title}}</h4>
    </div>
    <refresh-list
      class="search-content-list"
      :refresh-loading.sync="refreshLoading"
      :list-loading.sync="listLoading"
      :finished="finished"
      :error.sync="error"
      @refresh="onRefresh"
      @load="onLoad">
      <ul class="search-content-list-view">
        <li
          v-for="(item, index) in videoList"
          :key="index"
          class="search-content-list-view-cell"
          @click="liChange(index)">
          <div class="search-content-list-logo">
            <base-image
              class="search-content-list-logo-img"
              :ratio="360/243"
              encrypt
              :url="item.coverbase64.url"
              :type="item.coverbase64.type" />
          </div>
          <p class="search-content-list-title">{{item.title}}</p>
        </li>
      </ul>
    </refresh-list>
  </div>
</template>
<script>
import baseImage from '@/components/baseImage'
import refreshList from '@/components/refreshList'
import { searchList } from '@/API/search'
export default {
  name: 'searchList',
  components: {
    baseImage,
    refreshList
  },
  data () {
    return {
      videoList: [],
      queryData: {
        serach: '',
        page: 1
      },
      listLoading: false,
      refreshLoading: false,
      finished: false,
      error: false,
      tabnum: 30,
      title: ''
    }
  },
  created () {
    this.title = this.$route.query.search
    this.queryData.serach = this.$route.query.search
  },
  methods: {
    async onLoad () {
      await this.getVideoList()
    },
    async onRefresh () {
      this.videoList = []
      this.queryData.page = 1
      await this.getVideoList()
      this.$toast('刷新成功')
      this.refreshLoading = false
    },
    async getVideoList () {
      try {
        const res = await searchList(this.queryData)
        const { data, next_page_url: nextPageUrl } = res.rescont
        this.videoList = this.queryData.page === 1 ? data : this.videoList.concat(data)
        this.queryData.page = this.queryData.page + 1
        if (nextPageUrl === null) {
          this.listLoading = false
          this.finished = true
          return
        }
      } catch (err) {
        console.log(err)
        this.error = true
      }
      this.finished = false
      this.listLoading = false
    },
    liChange (index) {
      this.$router.push({
        path: '/playVideo',
        query: {
          id: this.videoList[index].id
        }
      })
    },
    back () {
      this.$router.go(-1) // 返回上壹層
    }
  }
}
</script>
<style scoped>

.van-tabs--card > .van-tabs__wrap {
  box-sizing: border-box;
  height: 44px;
  padding: 7px 0;
}

.van-tabs__nav--card {
  box-sizing: border-box;
  height: 26px;
  margin: 0 5px;
  border: 0 solid #ee0a24;
  border-radius: 2px;
}

.van-tabs__nav--card .van-tab {
  line-height: 24px;
  color: #ee0a24;
  border-right: 0 solid #ee0a24;
}

.van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff;
  background-color: #eab87f;
  border-radius: 16px;
}

.tasActive {
  background-color: #eab87f !important;
}

.sg-tag {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: left;
  width: 100%;
  height: 44px;
  padding: 10px 5px;
}

.sg-tag-item {
  box-sizing: border-box;
  height: 24px;
  padding: 2px 10px;
  margin-left: 10px;
  font-size: 13px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  background-color: #444;
  border-radius: 15px;
}

.search-content {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #1d1d1d;
}

.search-nav {
  position: absolute top：0px;
  right: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding: 0 40px;
  font-size: 18px;
  font-weight: 600;
  line-height: 44px;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
}

.search-nav h4 {
  width: 100%;
  height: 44px;
  padding: 0 0;
  margin: 0 0;
  font-weight: 600;
  line-height: 44px;
  color: #fff;
}

.search-nav-back {
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 40px;
  height: 44px;
  padding: 5px 10px;
}

.search-nav-back img {
  width: 100%;
}

.search-nav-search {
  position: absolute;
  top: 0;
  right: 0;
  box-sizing: border-box;
  width: 40px;
  height: 44px;
  padding: 5px 10px;
}

.search-nav-search img {
  width: 100%;
}

.navbar-content {
  position: relative;
  width: 100%;
  height: 90px;
  background-color: #111;
}

.search-content .search-content-list {
  position: absolute;
  top: 44px;
  right: 0;
  bottom: 10px;
  left: 0;
  width: 100%;
  overflow: auto;
}

.search-content-list-view {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 10px 15px 0 15px;
  margin: 0 0;
  list-style: none;
}

.search-content-list-view-cell {
  position: relative;
  width: 48%;
  margin-bottom: 10px;
}

.search-content-list-logo {
  position: relative;
  width: 100%;
  border-radius: 4px;
}

.search-content-list-logo-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
  object-fit: cover;
}

.search-content-list-title {
  width: 100%;
  margin: 0 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/searchList.vue